import { useState } from "react";

import { BsMetaUtil, StrategyExpandedInfo, useLoopscaleWalletContext } from "@bridgesplit/abf-react";
import { StatColumn } from "@bridgesplit/ui";
import { bsMath, formatAddress } from "@bridgesplit/utils";
import { TransactionTypes } from "app/types";

import { AppButton, PausedExternalYieldAlert, TokenInput } from "../../common";
import { useStrategyWithdraw } from "./util";

export default function StrategyWithdraw({ strategy }: { strategy: StrategyExpandedInfo | undefined }) {
    const [amount, setAmount] = useState<number>();

    const metadata = strategy?.principalMetadata;

    const {
        data: { userWalletAddress: activeWallet }
    } = useLoopscaleWalletContext();

    const symbol = BsMetaUtil.getSymbol(metadata);
    const maxBalance = strategy?.totalBalance;

    const insufficientBalance = amount ? !maxBalance || amount > maxBalance : false;

    const withdraw = useStrategyWithdraw();
    const withdrawAll = amount === maxBalance;

    return (
        <>
            <TokenInput
                symbol={symbol}
                label="Amount"
                maxText="Available"
                value={amount}
                setValue={setAmount}
                maxAmount={maxBalance}
                adornment={symbol}
                metadata={metadata}
                hideRefresh
            />
            <StatColumn
                stats={[
                    {
                        caption: "Withdraw to",
                        value: formatAddress(activeWallet)
                    },
                    {
                        caption: "Position balance",
                        symbol,
                        value: [
                            strategy?.totalBalance,
                            Math.max(bsMath.sub(strategy?.totalBalance, amount || 0) || 0, 0)
                        ],
                        hide: !amount
                    }
                ]}
            />
            <PausedExternalYieldAlert variant="strategy" source={strategy?.externalYieldInfo?.externalYieldSource} />
            <AppButton
                isTransaction
                transactionType={TransactionTypes.StrategyWithdraw}
                fullWidth
                asyncCta={{
                    options: { onSuccess: () => setAmount(undefined) },
                    onClickWithResult: () => withdraw({ strategy, amount, withdrawAll })
                }}
                disabled={!amount || insufficientBalance}
                variant="contained"
            >
                Withdraw
            </AppButton>
        </>
    );
}
